<script>
  import { Clubs } from '../../../middleware/database/clubs';
  import { Races } from '../../../middleware/database/races';
  import FinishedCard from './finished_card.svelte'
  import NotstartedCard from './notstarted_card.svelte'
  import { onMount, onDestroy } from 'svelte';
  import InprogressCard from './inprogress_card.svelte'
  import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';

  let urlParams = new URLSearchParams(window.location.search);
  let clubId = urlParams.get('clubId')
  let races = []; 
  let clubName = '';    
  let cancelFunc = null;
  let user = null;
  let userClubId = null;
  let auth = getAuth();
  let unsubscribe = null;

  async function handleLogout() {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  }

  async function handleDeleteRace(raceId) {
    try {
      await Races.remove(raceId, clubId);
      // The subscription will automatically update the races list
    } catch (error) {
      console.error('Error deleting race:', error);
      alert('Failed to delete race. Please try again.');
    }
  }

  function navigateToClub(newClubId) {
    window.location.href = `/results?clubId=${newClubId}`;
  }

  onMount(async () => {
    let club = await Clubs.findOne(clubId); 
    clubName = club.name; 
    
    cancelFunc = await Races.subscribeAll(clubId, (newRaces) => {
      races = newRaces;
    }); 

    // Subscribe to auth state changes
    unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      user = currentUser;
      if (currentUser) {
        try {
          const idTokenResult = await currentUser.getIdTokenResult();
          userClubId = idTokenResult.claims.clubId;
        } catch (error) {
          console.error('Error getting user claims:', error);
        }
      } else {
        userClubId = null;
      }
    });
  });
  
  onDestroy(() => {
    if (cancelFunc != null) {
      cancelFunc();
    }
    if (unsubscribe != null) {
      unsubscribe();
    }
  }); 

  $: canDelete = user && userClubId === clubId;
</script>

<style>
  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 2rem 0;
    padding-bottom: 1rem;
    border-bottom: 2px solid #e0e0e0;
  }

  .header-actions {
    display: flex;
    gap: 1rem;
    align-items: center;
  }

  .club-title {
    font-size: 2.5rem;
    color: #1b1c1c;
    margin: 0;
    font-weight: 500;
  }

  .latest-link {
    display: inline-flex;
    align-items: center;
    padding: 0.5rem 1rem;
    background-color: #1976D2;
    color: white;
    text-decoration: none;
    border-radius: 4px;
    transition: all 0.3s ease;
  }

  .login-link {
    display: inline-flex;
    align-items: center;
    padding: 0.5rem 1rem;
    color: #666;
    text-decoration: none;
    border-radius: 4px;
    transition: all 0.3s ease;
    border: 1px solid #e0e0e0;
    background-color: white;
  }

  .latest-link:hover {
    background-color: #1565C0;
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  .login-link:hover {
    background-color: #f5f5f5;
    color: #1976D2;
    border-color: #1976D2;
  }

  .latest-link i, .login-link i {
    margin-right: 8px;
    font-size: 1.2rem;
  }

  .races-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1.5rem;
    margin-top: 2rem;
  }

  @media (max-width: 600px) {
    .page-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
    }

    .header-actions {
      flex-direction: column;
      width: 100%;
    }

    .latest-link, .login-link {
      width: 100%;
      justify-content: center;
    }

    .races-grid {
      grid-template-columns: 1fr;
    }
  }

  .user-panel {
    background-color: #e3f2fd;
    border: 1px solid #bbdefb;
    border-radius: 4px;
    padding: 1rem;
    margin: 1.5rem 0 1rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #1976D2;
  }

  .user-info i {
    font-size: 1.2rem;
  }

  .user-email {
    font-size: 0.9rem;
  }

  .user-label {
    color: #666;
    margin-right: 0.5rem;
  }

  .logout-btn {
    display: inline-flex;
    align-items: center;
    padding: 0.5rem 1rem;
    background-color: #f5f5f5;
    color: #666;
    text-decoration: none;
    border-radius: 4px;
    transition: all 0.3s ease;
    border: 1px solid #e0e0e0;
    cursor: pointer;
    font-size: 0.9rem;
  }

  .logout-btn:hover {
    background-color: #e0e0e0;
    color: #333;
  }

  .logout-btn i {
    margin-right: 0.5rem;
  }

  .login-link.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  .warning-panel {
    background-color: #fff3e0;
    border: 1px solid #ffe0b2;
    border-radius: 4px;
    padding: 1rem;
    margin: 1rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .warning-info {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #e65100;
  }

  .warning-info i {
    font-size: 1.2rem;
  }

  .warning-text {
    font-size: 0.9rem;
  }

  .warning-link {
    display: inline-flex;
    align-items: center;
    padding: 0.5rem 1rem;
    background-color: #e65100;
    color: white;
    text-decoration: none;
    border-radius: 4px;
    transition: all 0.3s ease;
    font-size: 0.9rem;
  }

  .warning-link:hover {
    background-color: #f57c00;
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  .warning-link i {
    margin-right: 0.5rem;
  }
</style>

<main>
  <div class="container"> 
    {#if user}
      <div class="user-panel">
        <div class="user-info">
          <i class="material-icons">account_circle</i>
          <span class="user-label">Signed in as:</span>
          <span class="user-email">{user.email}</span>
        </div>
        <button class="logout-btn" on:click={handleLogout}>
          <i class="material-icons">logout</i>
          Sign Out
        </button>
      </div>

      {#if userClubId && userClubId !== clubId}
        <div class="warning-panel">
          <div class="warning-info">
            <i class="material-icons">warning</i>
            <span class="warning-text">You are viewing results for a different club than your assigned club.</span>
          </div>
          <button class="warning-link" on:click={() => navigateToClub(userClubId)}>
            <i class="material-icons">arrow_forward</i>
            Go to My Club
          </button>
        </div>
      {/if}
    {/if}

    <div class="page-header">
      <h2 class="club-title">{clubName}</h2>
      <div class="header-actions">
        <a href="results/race?clubId={clubId}" class="latest-link">
          <i class="material-icons">update</i>
          Open Latest Race
        </a>
        {#if !user}
          <a href="/login?clubId={clubId}" class="login-link">
            <i class="material-icons">account_circle</i>
            Sign In
          </a>
        {/if}
      </div>
    </div>

    <div class="races-grid">
      {#each races as race}
        {#if race.raceState === 'Finished'}
          <FinishedCard 
            bind:race={race} 
            {canDelete}
            onDelete={handleDeleteRace}
          />
        {:else if race.raceState === 'NotStarted'}
          <NotstartedCard 
            bind:race={race}
            {canDelete}
            onDelete={handleDeleteRace}
          />
        {:else}
          <InprogressCard bind:race={race}/>
        {/if}  
      {/each}
    </div>
  </div>
</main>